import React, { useEffect, useState } from 'react';
import { getMfView } from '@im/ui-lib/mf-utils';

type Props = {
  mfName: string;
  viewName: string;
};

export function LazyView(props: Props) {
  const { mfName, viewName } = props;

  const [View, setView] = useState<React.FC | undefined>();

  useEffect(() => {
    let active = true;
    if (mfName && viewName) {
      (async () => {
        const view = await getMfView(mfName, viewName);
        if (active && view) {
          // https://github.com/facebook/react/issues/19098
          setView(() => view);
        }
      })();
    }
    return () => {
      active = false;
    };
  }, [mfName, viewName]);

  return View ? <View /> : null;
}
